import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import { ConfirmProvider } from "./components/ConfirmDialog";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Communities from "./pages/Communities";
import CommunityDetail from "./pages/CommunityDetail";
import AuthoritiesList from "./pages/AuthoritiesList";
import AuthorityDetail from "./pages/AuthorityDetail";
import Commitments from "./pages/Commitments";
import CommitmentDetail from "./pages/CommitmentDetail";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Meetings from "./pages/Meetings";
import MeetingDetail from "./pages/MeetingDetail";
import RCA from "./pages/RCA";
import MapPage from "./pages/MapPage";
import Search from "./pages/Search";
import Alerts from "./pages/Alerts";
import Staff from "./pages/Staff";
import Agenda from "./pages/Agenda";
import AdminClients from "./pages/AdminClients";
import Goals from "./pages/Goals";
import UsersManagement from "./pages/UsersManagement";
import Landing from "./pages/Landing";
import Terminos from "./pages/legal/Terminos";
import Privacidad from "./pages/legal/Privacidad";
import Cookies from "./pages/legal/Cookies";
import CookieBanner from "./components/CookieBanner";
import Presentacion from "./pages/Presentacion";
import Brochures from "./pages/Brochures";
import PpFcab from "./pages/PpFcab";
import PpGore from "./pages/PpGore";
import PpMuniSG from "./pages/PpMuniSG";

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <Toaster richColors closeButton position="top-right" />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/login" element={<Login />} />
            <Route path="/presentacion" element={<Presentacion />} />
            <Route path="/brochures" element={<Brochures />} />
            <Route path="/pp-fcab" element={<PpFcab />} />
            <Route path="/pp-gore" element={<PpGore />} />
            <Route path="/pp-munisg" element={<PpMuniSG />} />
            <Route
              path="/admin/clientes"
              element={<ProtectedRoute requireRole="super_admin"><AdminClients /></ProtectedRoute>}
            />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/comunidades" element={<Communities />} />
              <Route path="/comunidades/:id" element={<CommunityDetail />} />

              <Route path="/autoridades-comunales"
                element={<AuthoritiesList entityType="comunal" title="Autoridades comunales"
                  description="Alcaldes, concejales y funcionarios municipales." detailRoute="/autoridades-comunales" />} />
              <Route path="/autoridades-comunales/:id" element={<AuthorityDetail entityType="comunal" listRoute="/autoridades-comunales" />} />

              <Route path="/autoridades-gobierno"
                element={<AuthoritiesList entityType="gobierno" title="Autoridades de Gobierno"
                  description="Delegación Presidencial, Seremis y representantes del Ejecutivo." detailRoute="/autoridades-gobierno" />} />
              <Route path="/autoridades-gobierno/:id" element={<AuthorityDetail entityType="gobierno" listRoute="/autoridades-gobierno" />} />

              <Route path="/parlamentarios"
                element={<AuthoritiesList entityType="parlamentario" title="Parlamentarios"
                  description="Senadores y Diputados de las distintas circunscripciones y distritos." detailRoute="/parlamentarios" />} />
              <Route path="/parlamentarios/:id" element={<AuthorityDetail entityType="parlamentario" listRoute="/parlamentarios" />} />

              <Route path="/autoridades-gore"
                element={<AuthoritiesList entityType="gore" title="Autoridades GORE"
                  description="Gobernador y jefes de unidades del Gobierno Regional." detailRoute="/autoridades-gore" />} />
              <Route path="/autoridades-gore/:id" element={<AuthorityDetail entityType="gore" listRoute="/autoridades-gore" />} />

              <Route path="/organizaciones"
                element={<AuthoritiesList entityType="organizacion" title="Organizaciones, gremios e instituciones"
                  description="Gremios, organizaciones, presidentes, directorios y representantes." detailRoute="/organizaciones" />} />
              <Route path="/organizaciones/:id" element={<AuthorityDetail entityType="organizacion" listRoute="/organizaciones" />} />

              <Route path="/compromisos" element={<Commitments />} />
              <Route path="/compromisos/:id" element={<CommitmentDetail />} />
              <Route path="/proyectos" element={<Projects />} />
              <Route path="/proyectos/:id" element={<ProjectDetail />} />
              <Route path="/reuniones" element={<Meetings />} />
              <Route path="/reuniones/:id" element={<MeetingDetail />} />
              <Route path="/rca" element={<RCA />} />
              <Route path="/mapa" element={<MapPage />} />
              <Route path="/buscador" element={<Search />} />
              <Route path="/alertas" element={<Alerts />} />
              <Route path="/equipo" element={<Staff />} />
              <Route path="/usuarios" element={<UsersManagement />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/metas" element={<Goals />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
